import React, { Component } from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { updateVehicle } from "../../graphql/mutations";
import { API, graphqlOperation } from "aws-amplify";

import { spinnerService } from "@chevtek/react-spinners";
// core components
import { Link } from "react-router-dom";
import tableStyle from "../../assets/jss/material-dashboard-react/components/tableStyle.jsx";

import { toast } from "react-toastify";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import moment from "moment";
export function AlertDialog(prop) {
  const [open, setOpen] = React.useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  async function handleClose() {
    setOpen(false);
    var input = {
      id: prop.id,
      vehicleStatus: "RETIRED"
    };
    spinnerService.show("mySpinner");
    var result = await API.graphql(graphqlOperation(updateVehicle, { input }));
    spinnerService.hide("mySpinner");
    toast.success("Vehicle Archived");
    prop.loadData();
  }

  return (
    <div>
      <span style={{ cursor: "pointer" }} onClick={handleClickOpen}>
        Archive
      </span>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{
            width: 365,
            background: "linear-gradient(60deg, #017BFF, #CCE5FF)"
          }}
        >
          {"Archive Confirmation"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ padding: 24, paddingBottom: 0, fontWeight: "bold" }}
            className="color-danger"
          >
            Are you sure!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpen(false)}
            color="primary"
            className="bg-light"
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleClose()}
            color="white"
            className="bg-primary"
            autoFocus
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

class CustomTable extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      classes,
      tableHead,
      tableData,
      tableHeaderColor,
      client,
      inspections
    } = this.props;
    
    if (inspections !== undefined) {
      let today = new Date();
      return (
        <div className={classes.tableResponsive}>
          <Table className={classes.table}>
            <TableHead className={classes[tableHeaderColor + "TableHeader"]}>
              <TableRow>
                {tableHead !== undefined
                  ? tableHead.map((heading, key) => {
                      return (
                        <TableCell
                          className={
                            classes.tableCell + " " + classes.tableHeadCell
                          }
                          key={key}
                        >
                          {heading}
                        </TableCell>
                      );
                    }, this)
                  : null}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.length !== 0
                ? tableData.map((dataProp, key) => {
                    let dateClasses = "";
                    if (new Date(dataProp.nextInspectionDue) < today) {
                      dateClasses = "bg-purple";
                    } else if (
                      new Date(dataProp.nextInspectionDue) > today &&
                      moment(dataProp.nextInspectionDue) <
                        moment(today).add(7, "days")
                    ) {
                      dateClasses = "bg-red";
                    } else if (
                      moment(dataProp.nextInspectionDue) >
                        moment(today).add(7, "days") &&
                      moment(dataProp.nextInspectionDue) <
                        moment(today).add(15, "days")
                    ) {
                      dateClasses = "bg-yellow";
                    } else if (
                      moment(dataProp.nextInspectionDue) >
                        moment(today).add(15, "days") &&
                      moment(dataProp.nextInspectionDue) <
                        moment(today).add(30, "days")
                    ) {
                      dateClasses = "bg-lightgreen";
                    } else if (
                      moment(dataProp.nextInspectionDue) >
                      moment(today).add(30, "days")
                    ) {
                      dateClasses = "bg-lightgreen";
                    }
                    return (
                      <TableRow key={key}>
                        {dataProp.vehicle !== null ? (
                          <TableCell className={classes.tableCell}>
                            {dataProp.vehicle.customerVehicleId}
                          </TableCell>
                        ) : (
                          <TableCell className={classes.tableCell}>
                            {1}
                          </TableCell>
                        )}
                        {dataProp.vehicle !== null ? (
                          <TableCell className={classes.tableCell}>
                            {dataProp.vehicle.id}
                          </TableCell>
                        ) : (
                          <TableCell className={classes.tableCell}>
                            {2}
                          </TableCell>
                        )}
                        <TableCell className={classes.tableCell}>
                          {dataProp.inspectionType}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {dataProp.startAt}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {dataProp.inspectionStatus}
                        </TableCell>
                        {dataProp.vehicle !== null ? (
                          <TableCell
                            className={classes.tableCell + "" + dateClasses}
                          >
                            <Link
                              to={{
                                pathname: `/inspections/${dataProp.id}`,
                                client: { client }
                              }}
                            >
                              {"Details"}
                            </Link>
                          </TableCell>
                        ) : (
                          <TableCell className={classes.tableCell}>
                            {"Details"}
                          </TableCell>
                        )}
                      </TableRow>
                    );
                  }, this)
                : null}
            </TableBody>
          </Table>
        </div>
      );
    }
    let i = -1;
    return (
      <div className={classes.tableResponsive}>
        <Table className={classes.table}>
          {tableHead !== undefined ? (
            <TableHead className={classes[tableHeaderColor + "TableHeader"]}>
              <TableRow>
                {tableHead.map((prop, key) => {
                  return (
                    <TableCell
                      className={
                        classes.tableCell + " " + classes.tableHeadCell
                      }
                      key={key}
                    >
                      {prop}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
          ) : null}
          <TableBody>
            {tableData.length !== null &&
              tableData.map((propParent, key) => {
                i = -1;
                return (
                  <TableRow key={key}>
                    {propParent.map((prop, key) => {
                      i++;
                      if (i === 0) return;
                      if (prop === "Details") {
                        return (
                          <TableCell className={classes.tableCell} key={key}>
                            <Link
                              to={{
                                pathname: `/company/vehicle/${propParent[0]}`,
                                client: { client }
                              }}
                            >
                              {" "}
                              {prop}
                            </Link>
                          </TableCell>
                        );
                      }
                      if (prop === "Edit") {
                        return (
                          <TableCell className={classes.tableCell} key={key}>
                            <Link
                              to={{
                                pathname: `/company/edit/${propParent[0]}`,
                                client: { client }
                              }}
                            >
                              {" "}
                              {prop}
                            </Link>
                          </TableCell>
                        );
                      }
                      if (prop === "Del") {
                        return (
                          <TableCell className={classes.tableCell} key={key}>
                            <AlertDialog
                              id={propParent[0]}
                              loadData={this.props.loadData}
                            />
                          </TableCell>
                        );
                      }
                      return (
                        <TableCell className={classes.tableCell} key={key}>
                          {key === 4 ? (
                            <div>
                              {prop.slice(0, 9).toString()}
                              <strong
                                style={{ fontSize: 18, fontWeight: "bolder" }}
                              >
                                {prop.slice(9, 11).toString()}
                              </strong>
                              <strong
                                style={{ fontSize: 18, fontWeight: "bolder" }}
                              >
                                <i>{prop.slice(11, 17).toString()}</i>
                              </strong>
                            </div>
                          ) : (
                            prop
                          )}
                          {/* <div dangerouslySetInnerHTML={{ __html: prop }} /> */}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </div>
    );
  }
}

CustomTable.defaultProps = {
  tableHeaderColor: "gray"
};

CustomTable.propTypes = {
  classes: PropTypes.object.isRequired,
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};

export default withStyles(tableStyle)(CustomTable);



// WEBPACK FOOTER //
// ./src/components/Table/Table.jsx